<template>
  <div class="patient-identity">
    <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
      <span class="form-label mb-0">{{ form.is_foreign ? 'RNM/RNE (CRNM)' : 'CPF' }} <span class="text-danger">*</span></span>
      <label class="d-inline-flex align-items-center gap-2 mb-0 small" style="white-space: nowrap; cursor: pointer">
        <input class="form-check-input m-0" type="checkbox" :checked="form.is_foreign" :disabled="disabled" @change="toggleForeign($event.target.checked)">
        Estrangeiro?
      </label>
    </div>
    <input v-if="form.is_foreign" v-model="form.document_number" class="form-control form-control-solid" :disabled="disabled" maxlength="12" required autocapitalize="characters" placeholder="Ex.: A1234567" aria-label="RNM/RNE" @blur="validate">
    <input v-else v-model="form[cpfField]" v-mask="'###.###.###-##'" class="form-control form-control-solid" :disabled="disabled" required placeholder="000.000.000-00" aria-label="CPF" @blur="validate">
    <PatientNationalityField v-if="form.is_foreign && showNationality" class="mt-3" :form="form" :disabled="disabled" />
    <button v-if="foundPatient && allowSelect" type="button" class="btn btn-link p-0 mt-2" @click="$emit('select', foundPatient)">
      Selecionar {{ foundPatient.patient_name }} — {{ foundPatient.document_number || foundPatient.patient_cpf }}
    </button>
    <div v-if="message" class="mt-1 small" :class="invalid ? 'text-danger' : 'text-muted'" aria-live="polite">{{ message }}</div>
  </div>
</template>

<script>
import http from '../helpers/http';
import PatientNationalityField from './PatientNationalityField.vue';
import { mask } from 'vue-the-mask';
export default {
  components: { PatientNationalityField },
  directives: { mask },
  props: {
    form: { type: Object, required: true },
    cpfField: { type: String, default: 'patient_cpf' },
    disabled: Boolean,
    allowSelect: Boolean,
    showNationality: { type: Boolean, default: true },
  },
  data: () => ({
    foundPatient: null, message: '', invalid: false, requestVersion: 0,
  }),
  computed: {
    alternative() { return !!this.form.is_foreign; },
    identityKey() { return JSON.stringify([this.form.is_foreign, this.form.nationality, this.form.document_type, this.form.document_country, this.form.document_number, this.form[this.cpfField]]); },
  },
  watch: { identityKey() { this.requestVersion++; this.message = ''; this.foundPatient = null; } },
  methods: {
    toggleForeign(value) {
      this.form.is_foreign = value;
      this.form.nationality = this.form.nationality || null;
      this.form.document_type = value ? 'residence' : null;
      this.form.document_country = value ? 'BR' : null;
      this.form.document_number = null;
      if (value) this.form[this.cpfField] = null;
      else this.form.nationality = null;
    },
    async validate() {
      if (this.disabled) return;
      const version = ++this.requestVersion;
      this.invalid = false; this.message = 'Validando formato…';
      try {
        const { data: validation } = await http.post('/identity-documents/validate', {
          is_foreign: !!this.form.is_foreign, nationality: this.form.nationality,
          document_type: this.form.document_type, document_country: this.form.document_country,
          document_number: this.form.document_number, patient_cpf: this.form[this.cpfField],
        });
        if (version !== this.requestVersion) return;
        this.message = validation.message;
        const placeId = this.$store.state.auth.place?.id_place;
        if (this.allowSelect && placeId) {
          const search = this.alternative ? validation.identity.document_number : validation.identity.patient_cpf;
          const { data } = await http.get(`/places/${placeId}/patients`, { params: { search } });
          if (version !== this.requestVersion) return;
          this.foundPatient = (data.data || []).find(patient => this.alternative
            ? patient.document_type === this.form.document_type && patient.document_country === this.form.document_country && patient.document_number === search.trim().toUpperCase()
            : patient.patient_cpf === search.replace(/\D/g, '')) || null;
          if (this.foundPatient) this.message = 'Documento já cadastrado. Selecione o paciente para reutilizar seus dados.';
        }
      } catch (error) {
        if (version !== this.requestVersion) return;
        this.invalid = true;
        this.message = Object.values(error.response?.data?.errors || {}).flat()[0] || 'Não foi possível validar o documento. Tente novamente.';
      }
    },
  },
};
</script>
